import { Button, makeStyles, Text } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Smoke } from '../model/Smoke';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { slThemeLight } from "../slTheme";
import { LabeledItem, LabeledItemPositions } from './LabeledItem';
import { slStyles } from '../slStyles';
import { EditRegular, DeleteRegular } from "@fluentui/react-icons";
import { RexDateNoTime } from "../Dates/RexDateNoTime";
import { RexDateTime } from "../Dates/RexDateTime";
import { ClickEditDelegate, ClickDeleteDelegate } from "../model/ItemDelegates";

export interface SmokeItemProps
{
    styles: Record<string, string>;
    smoke: Smoke;
    onEdit?: ClickEditDelegate<Smoke>;
    onDelete?: ClickDeleteDelegate<Smoke>;
}

export interface SmokeItemState
{
}

const useStyles = makeStyles(
    {
        smokeContainer:
        {
            ...slStyles.detailContainer
        },
        smokeHeader:
        {
            ...slStyles.detailHeader
        },
        smokeHeaderPrep:
        {
            ...slStyles.detailBoxed
        },
        smokeHeaderHero:
        {
            ...slStyles.detailHeaderHeroText
        }
    });

export class SmokeItemWithoutStyles extends React.Component<SmokeItemProps, SmokeItemState>
{
    onEdit(event: React.MouseEvent<HTMLButtonElement>)
    {
        if (this.props.onEdit)
        {
            this.props.onEdit(event, this.props.smoke);
        }
    }

    onDelete(event: React.MouseEvent<HTMLButtonElement>)
    {
        if (this.props.onDelete)
        {
            this.props.onDelete(event, this.props.smoke);
        }
    }

    render()
    {
        const smoke: Smoke = this.props.smoke;
        const date = (smoke.Date as RexDateTime).toLongDateString();
        const onEdit = this.onEdit.bind(this);
        const onDelete = this.onDelete.bind(this);

        return (
            <div className={this.props.styles.smokeContainer}>
                <div className={this.props.styles.smokeHeader}>
                    <div><Text className={this.props.styles.smokeHeaderHero}>{smoke.Description}</Text> ({smoke.SmokeID})</div>
                    <div>{smoke.Weather}</div>
                    <div>{date}</div>
                    <div>
                        {this.props.onEdit && (<Button aria-label="Edit" icon={<EditRegular/>} onClick={onEdit}/>)}
                        {this.props.onDelete && (<Button aria-label="Delete" icon={<DeleteRegular/>} onClick={onDelete}/>)}
                    </div>
                </div>
                <div className={this.props.styles.smokeHeader}>
                    <LabeledItem label="wood (buried)" text={smoke.BuriedWood} position={LabeledItemPositions.Below}/>
                    <LabeledItem label="wood (on top)" text={smoke.FloatWood} position={LabeledItemPositions.Below}/>
                    <LabeledItem label="charcoal" text={smoke.Charcoal} position={LabeledItemPositions.Below}/>
                </div>
                <div className={this.props.styles.smokeHeaderPrep}>
                    <LabeledItem border label="Smoker Preparation" text={smoke.SmokerPrep} position={LabeledItemPositions.Above}/>
                </div>
            </div>
        );
    }
}

export const SmokeItem = withStyles(useStyles, SmokeItemWithoutStyles);